import React, {Component} from 'react';
import PropTypes from "prop-types";
import {change, Field} from 'redux-form';
import {compose} from "recompose";
import {connect} from "react-redux";
import axios from 'axios';
import {RESOURCES as productResources} from '../fuseProductsResourceMap';
import {checkTokenStatus} from '../shared/tokenFunctions';
import {
    required
} from 'admin-on-rest';
import FuseTheme from "../global/theme";
import TextField from 'material-ui/TextField';

/**
 * Set a field for form entry
 *
 * @param touched
 * @param error
 * @param inputProps
 * @param props
 * @return {*}
 */
const renderInput = ({meta: {touched, error} = {}, input: {...inputProps}, ...props}) => {
    return (
        <TextField
            errorText={touched && error}
            {...inputProps}
            {...props}
            fullWidth
        />
    )
};

/**
 * A Text Input that verifies the uniqueness of its value.
 *
 */
class ValidatedProductTypeNameInput extends Component {
    constructor(props) {
        super(props);
        const {record, source = 'record-form'} = this.props;
        const currentValue = record && record[source] ? record[source] : '';
        this.state = {
            inputValue: currentValue,
            isDuplicate: false,
            isValid: false,
            needToValidate: true,
            showMessage: false,
            sourceValue: currentValue,
            submitting: false,
            tableName: '',
            productTypesList: []
        };

        this.handleInputChange = this.handleInputChange.bind(this);
    }

    componentDidMount() {
        this.fetchProductTypes();
        const {record, source, formName = 'record-form'} = this.props;
        const currentValue = record && record[source] ? record[source] : '';
        if (currentValue) {
            this.setState({
                isValid: true,
                needToValidate: true,
                showMessage: false,
            });
            // populate the visible “check” field so the user actually sees the value
            this.props.dispatch(change(formName, `${source}_check`, currentValue));
        }
    }

    fetchProductTypes() {
        const resource = productResources["ProductTypes"].GET_LIST();
        import('../shared/functions')
            .then(functions => {
                const tokenStatus = checkTokenStatus(null);
                if (tokenStatus.expired) {
                    return;
                }
                axios({
                    method: 'get',
                    url: resource.uri,
                    headers: functions.getGetHeaders()
                }).then((result) => {
                    // If there is a return value, this value already exists
                    if (result.data.payload && result.data.payload.length > 0) {
                        this.setState({
                            productTypesList: result.data.payload,
                        });
                    }
                }).catch((error) => {
                    if (error.response) {
                        // Server response outside 2xx
                        console.log(error.response.data);
                    } else if (error.request) {
                        // No response
                        console.log(error.request);
                    } else {
                        console.log('Error', error.message);
                    }
                });
            });
    }

    /**
     * Checks for validation errors
     *
     * @return {*}
     */
    handleRequiredValidation = () => {
        let error = null;
        if (this.state) {
            if (!this.state.inputValue && this.state.needToValidate) {
                error = this.props.errorRequiredMessage;
            }
            if (this.state.inputValue && this.state.isDuplicate) {
                error = this.props.errorDuplicateMessage;
            }
        }
        return error;
    };

    validateRequired = [required, this.handleRequiredValidation];

    /**
     * Handle input field change event
     *
     * @param event
     * @param newValue
     */
    handleInputChange(event, newValue) {
        const exists = this.state.productTypesList.some(item => {
            if (!item || !item.name) return false;
            return item.name.toLowerCase().trim() === (newValue || '').toLowerCase().trim();
        });
        if (!exists || (this.props.formType === 'edit' && newValue === this.props.record[this.props.source])) {
            this.setState({
                inputValue: newValue,
                isDuplicate: false,
                isValid: true,
                needToValidate: true,
                showMessage: false,
                sourceValue: newValue,
            }, () => {
                this.props.dispatch(change('record-form', this.props.source, newValue));
            });
        } else {
            this.setState({
                inputValue: newValue,
                isDuplicate: true,
                isValid: false,
                needToValidate: false,
                showMessage: true,
                sourceValue: newValue,
            }, () => {
                this.props.dispatch(change('record-form', this.props.source, newValue));
            });
        }
    }


    render() {
        const {
            label,
            source,
        } = this.props;

        const styles = {
            buttonContainer: {
                display: 'inline-block',
                margin: '16px 0 0 1em',
                verticalAlign: 'top',
            },
            errorText: {
                display: 'block',
                fontSize: 12,
                color: FuseTheme.palette.errorColor,
                margin: '0 0 1em 0',
            },
            field: {
                width: 256,
                marginTop: '-14px',
            },
            hidden: {
                display: 'none',
                visibility: 'none',
            },
            loader: {
                display: 'inline-block',
                margin: '0 0 0 8px',
                verticalAlign: 'middle',
            },
            messageText: {
                display: 'block',
                fontSize: 12,
                color: FuseTheme.palette.correctColor,
                margin: '0 0 1em 0',
            },
        };

        return (
            <div>
                {/* Entry field and source field */}
                <Field key={`input-${source}`}
                       name={`${source}_check`}
                       type={this.props.fieldType}
                       component={renderInput}
                       floatingLabelText={label}
                       onChange={this.handleInputChange}
                       validate={this.validateRequired}
                       style={styles.field}
                />
                <Field key={`input-value-${source}`}
                       name={source}
                       component="input"
                       type="text"
                       value={this.state.sourceValue}
                       style={styles.hidden}
                />

            </div>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    if (ownProps && ownProps.formName) {
        let form = state.form[ownProps.formName];
        if (form && form.values) {
            const parentFieldValue = (form.values[ownProps.parentField]) ? form.values[ownProps.parentField].toString() : null;
            return {
                parentFieldValue: parentFieldValue
            }
        }
    }
    return {
        typeValue: null
    }
};

ValidatedProductTypeNameInput.propTypes = {
    addField: PropTypes.bool,
    buttonLabel: PropTypes.string,
    errorDuplicateMessage: PropTypes.string,
    errorRequiredMessage: PropTypes.string,
    errorValidateMessage: PropTypes.string,
    fieldType: PropTypes.string,
    formName: PropTypes.string,
    formType: PropTypes.string,
    isRequired: PropTypes.bool,
    label: PropTypes.string,
    lookupType: PropTypes.string,
    parentField: PropTypes.string,
    parentFieldValue: PropTypes.string,
    successMessage: PropTypes.string,
};

ValidatedProductTypeNameInput.defaultProps = {
    addField: true,
    buttonLabel: "Check Availability",
    errorDuplicateMessage: "This value already exists.",
    errorRequiredMessage: "This value must be unique.",
    errorValidateMessage: "This value must be verified.",
    fieldType: "text",
    isRequired: true,
    successMessage: "This value is available.",
};

const enhance = compose(
    connect(mapStateToProps)
);

export default enhance(ValidatedProductTypeNameInput);



// WEBPACK FOOTER //
// ./src/Fuse/components/ValidateProductTypeNameInput.js